import router from '@/router';
import axios from 'axios';
import { ElMessage } from 'element-plus';
import {decrypt} from '@/utils/func'

let baseURL = window.api
const service = axios.create({
  baseURL,
  timeout: 30000 // request timeout
});
// 
service.interceptors.request.use(
  config => {
    const token_type = localStorage.getItem('token_type');
    const token = localStorage.getItem('Token');
    if (token) {
      config.headers['Authorization'] = token_type + ' ' + token;
    }
    return config
  }
)
service.interceptors.response.use(
  res => {
    if(res.data.encryption){
      const result=JSON.parse(decrypt(res.data.encryption));
      return result
    }
    if (res.data.code === 0) {
      return res.data;
    }
    else {
      return res.data
    }
  },
  err => {
    console.log(err, 'err');
    if (err.request.status == 401) {
      router.push('/login')
      ElMessage.error(err.response.data.msg || '登录过期');
    }
    else if (err.request.status == 424) {
      router.push('/login')
      ElMessage.error(err.response.data.msg || '登录过期');
    }
    else {
      ElMessage.error(err.response.data.msg || '网络请求失败，反馈给客服');
      return err.response.data
    }
  }
);


const post = (url, data, config = {}) => {
  config.url = url
  config.data = data
  config.method = 'post'
  return service(config)
}
const put = (url, data, config = { headers: { 'http-method': "PUT" } }) => {
  config.url = url
  config.data = data
  config.method = 'post'
  return service(config)
}
/**
* get 请求
* @param {*} url 请求链接
* @param {*} params 请求参数
* @param {*} config  额外配置
*/


const get = (url, params = {}, config = {}) => {
  config.url = url
  config.params = params
  if(!url.includes('sys-file/oss/file')) config.params._t = new Date().getTime()
  config.method = 'get'
  return service(config)
}

const deleteOp = (url, params = {}, config = { headers: { 'http-method': "DELETE" } }) => {
  config.url = url
  config.params = params
  config.method = 'post'
  return service(config)
}

const loginPost = (url, data, config = {
  headers: { 'Content-Type': "application/x-www-form-urlencoded" }
}) => {
  const configUrl = url + '&randomStr=' + "blockPuzzle" + '&username=' + data.username
  config.url = configUrl
  config.params = { code: data.code }
  config.data = { password: data.password, emailCode: data.emailCode }
  config.method = 'post'
  return service(config)
}
const reqCheckPost = (url, data, config = {
  headers: { 'Content-Type': "application/x-www-form-urlencoded" }
}) => {
  const configUrl = url + '?captchaType=' + "blockPuzzle" + "&pointJson=" + encodeURIComponent(data.pointJson) + '&token=' + encodeURIComponent(data.token)
  config.url = configUrl
  config.data = data
  config.method = 'post'
  return service(config)
}
const refreshPost = (url, data, config = {
  headers: { 'Content-Type': "application/x-www-form-urlencoded" }
}) => {
  config.url = url
  config.data = data
  config.method = 'post'
  return service(config)
}

export { get, post, deleteOp, put, loginPost, refreshPost, reqCheckPost }